import { TanstackRouterQueryParamsAdapter } from "util/TanstackRouterQueryParamsAdapter";
import { PropsWithChildren } from "react";
import { QueryParamProvider } from "use-query-params";

export function LegacyQueryParamProvider(params: PropsWithChildren) {
  return (
    <QueryParamProvider
      adapter={TanstackRouterQueryParamsAdapter}
      options={{
        enableBatching: true,
      }}
    >
      {params.children}
    </QueryParamProvider>
  );
}
